(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qunature-cart-rewards"]) return;
  try {
    
(() => {
  'use strict';
  const MARKER = '_QUNATURE Belohnung';
  const sceneProducts = new Set([16184449237326,16184452055374,16184454480206,16184455004494,16184455364942]);
  const hasScenePack = cart => cart.items.some(item => sceneProducts.has(Number(item.product_id)));
  const managed = (cart, config) => cart.items.filter(item =>
    config.giftProducts.includes(item.product_id) && item.properties?.[MARKER] === 'Gratis Geschenk');
  const ownCode = (code, config) => config.codes.some(value => value.toLowerCase() === code.toLowerCase());
  const foreignCodes = (cart, config) => (cart.discount_codes || []).filter(code => !ownCode(code.code, config));
  const fingerprint = lines => lines.map(line => `${line.key}:${line.quantity}`).sort().join('|');
  const packMainProducts = new Set([16184449237326,16184452055374,16184454480206]);
  const packGiftThresholds = {16184455004494:25000,16184455364942:40000};
  function hasCampaignGift(cart, config, map) {
    const standardIds=[...(config.legacyGiftProducts || config.giftProducts),...(map?.tiers || []).map(t=>Number(t.giftProductId))];
    return cart.items.some(item=>(packGiftThresholds[item.product_id] && item.properties?._QN_SCENE==='20261023') || (standardIds.includes(Number(item.product_id)) && item.properties?.[MARKER]==='Gratis Geschenk'));
  }
  function staleCampaignGiftKeys(cart, config, map) {
    const mains=cart.items.filter(item=>packMainProducts.has(Number(item.product_id)));
    const packAmount=mains.reduce((sum,item)=>sum+item.final_line_price,0);
    const packGifts=cart.items.filter(item=>packGiftThresholds[item.product_id] && item.properties?._QN_SCENE==='20261023');
    const validPackGift=packGifts.filter(item=>mains.length && packAmount>=packGiftThresholds[item.product_id] && item.quantity===1 && item.final_line_price===0).sort((a,b)=>packGiftThresholds[b.product_id]-packGiftThresholds[a.product_id])[0];
    const stale=new Set(packGifts.filter(item=>item!==validPackGift).map(item=>item.key));
    const singleEnabled=map?.enabled===true && map?.verified===true;
    const singleSources=cart.items.some(item=>map?.eligibleVariants[String(item.variant_id)]);
    const legacyIds=config.legacyGiftProducts || config.giftProducts;
    const singleIds=(map?.tiers || []).map(t=>Number(t.giftProductId));
    for(const item of cart.items){
      if(item.properties?.[MARKER]!=='Gratis Geschenk')continue;
      if(legacyIds.includes(Number(item.product_id)) && !singleIds.includes(Number(item.product_id)) && (mains.length || (singleEnabled && singleSources)))stale.add(item.key);
      if(singleIds.includes(Number(item.product_id)) && mains.length)stale.add(item.key);
    }
    return [...stale];
  }
  function singleConfig(config, cart, map) {
    if (!map || map.schema !== 1 || map.amountBasis !== 'final_line_price') return config;
    const giftProducts = map.tiers.map(t => Number(t.giftProductId));
    if (!cart.items.some(item => map.eligibleVariants[String(item.variant_id)] || giftProducts.includes(Number(item.product_id)))) return config;
    return {...config, single:true, enabled:map.enabled === true && map.verified === true,
      eligibleVariants:map.eligibleVariants, thresholds:map.thresholds, giftProducts, legacyGiftProducts:config.giftProducts, codes:[], singleMap:map,
      variants:map.tiers.flatMap((t,i)=>t.variants.map(v=>({...v,id:Number(v.id),tier:i+1,available:v.available !== false}))),
      text:{...config.text, heading:'Dein kostenloses Geschenk',choose:'Bitte wähle die passenden Größen.',
        prompt:'Wähle deine Geschenkgrößen im Warenkorb.', conflict:'Bitte entferne andere Rabattcodes, bevor du dieses Geschenk wählst. Die Aktionen sind nicht kombinierbar.',
        error:'Das kostenlose Geschenk konnte nicht bestätigt werden. Bitte prüfe den Warenkorb, bevor du erneut hinzufügst.',
        ready:'Dein Geschenk ist kostenlos im Warenkorb.',removed:'Deine Geschenkauswahl wurde an den aktuellen Warenkorb angepasst.'}};
  }
  function evaluate(cart, config, now = Date.now()) {
    const gifts = managed(cart, config);
    if (config.single) {
      const scenePack = hasScenePack(cart) || config.hasScenePack === true;
      const subtotal = cart.items.reduce((sum,item)=>sum+(config.eligibleVariants[String(item.variant_id)] ? item.final_line_price : 0),0);
      const active = config.enabled && !scenePack && config.currency === 'EUR';
      const tier = active ? config.thresholds.reduce((level,threshold,index)=>subtotal>=threshold?index+1:level,0) : 0;
      const validGift = gifts.length > 0 && gifts.reduce((n,item)=>n+item.quantity,0)===1 && gifts.reduce((n,item)=>n+item.final_line_price,0)===0 && gifts.every(item=>config.variants.some(v=>v.id===item.variant_id && v.tier===tier));
      return {gifts,subtotal,tier,active,validGift,scenePack};
    }
    const eligibleKeys = new Set(config.lines.filter(line => line.eligible).map(line => line.key));
    const subtotal = cart.items.reduce((sum, item) => sum +
      (eligibleKeys.has(item.key) && !config.giftProducts.includes(item.product_id) ? item.original_line_price : 0), 0);
    const campaignActive = config.collection && config.currency === 'EUR' && (!config.ends || now < Date.parse(config.ends));
    const eligibilityTier = campaignActive ? (subtotal >= config.thresholds[1] ? 2 : subtotal >= config.thresholds[0] ? 1 : 0) : 0;
    const scenePack = hasScenePack(cart) || (cart.items.length === 0 && config.hasScenePack === true);
    const active = config.enabled && campaignActive && !scenePack;
    const tier = active ? eligibilityTier : 0;
    const validGift = gifts.length === 1 && gifts[0].quantity === 1 && gifts[0].final_line_price === 0 &&
      config.variants.some(v => v.id === gifts[0].variant_id && v.tier === eligibilityTier) &&
      (cart.discount_codes || []).some(code => code.applicable && ownCode(code.code, config));
    return { gifts, subtotal, tier, active, validGift, scenePack };
  }
  class Rewards {
    constructor(config, singleMap) {
      this.singleMap = singleMap;
      this.config = singleConfig(config,{items:config.lines},singleMap);
      this.campaignPage = config.campaignPage;
      this.cart = { items: config.lines };
      this.state = evaluate(this.cart, this.config);
      this.busy = false;
      this.message = '';
      this.pendingCheckout = null;
      this.allowSubmit = false;
      this.selected = '';
      this.size = '';
      this.color = '';
      this.idleWaiters = [];
      this.refreshTimer = null;
    }
    async request(path, body, asText = false) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      try {
        const response = await fetch(this.config.root.replace(/\/$/, '') + '/' + path, {
          method: body === undefined ? 'GET' : 'POST', credentials: 'same-origin', cache: 'no-store',
          signal: controller.signal,
          headers: body === undefined ? {} : { 'Content-Type': 'application/json' },
          ...(body === undefined ? {} : { body: JSON.stringify(body) })
        });
        if (!response.ok) throw new Error('Cart request failed');
        return asText ? response.text() : response.json();
      } finally { clearTimeout(timeout); }
    }
    previewQuery() { return this.config.preview ? `&preview_theme_id=${this.config.theme}` : ''; }
    async read() {
      // Liquid checks actual collection membership; match snapshots before making any decision.
      for (let attempt = 0; attempt < 3; attempt++) {
        const [cart, html] = await Promise.all([
          this.request('cart.js'),
          this.request(`cart?section_id=qunature-cart-rewards${this.previewQuery()}&_qn=${Date.now()}`, undefined, true)
        ]);
        const node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-qn-cart-rewards]');
        if (!node) throw new Error('Reward configuration unavailable');
        const config = JSON.parse(node.textContent);
        if (fingerprint(cart.items) !== fingerprint(config.lines)) continue;
        this.cart = cart;
        this.config = singleConfig(config,cart,this.singleMap);
        this.state = evaluate(cart, this.config);
        return;
      }
      throw new Error('Cart changed while checking rewards');
    }
    async removeGifts() {
      const cart = await this.request('cart.js');
      const gifts = managed(cart, this.config);
      if (gifts.length) {
        const updates = Object.fromEntries(gifts.map(item => [item.key, 0]));
        await this.request('cart/update.js', { updates });
      }
      const codes = foreignCodes(cart, this.config).map(item => item.code);
      if ((cart.discount_codes || []).some(item => ownCode(item.code, this.config))) {
        await this.request('cart/update.js', { discount: codes.join(',') });
      }
    }
    async reconcile() {
      const staleKeys=staleCampaignGiftKeys(this.cart,this.config,this.singleMap);
      if(staleKeys.length){
        // Only exact campaign parent products carrying their own activity marker are removed.
        // Keep ordinary paid copies and all customer-entered discount codes untouched.
        await this.request('cart/update.js',{updates:Object.fromEntries(staleKeys.map(key=>[key,0]))});
        await this.read();
        this.message='Nicht mehr passende Aktionsgeschenke wurden entfernt. Deine übrigen Artikel und Rabattcodes bleiben erhalten.';
        return true;
      }
      if (this.config.single && !this.config.enabled) return false;
      if (this.state.gifts.length && !this.state.validGift) {
        // Never leave a paid, duplicate or ineligible promotional gift in the cart.
        await this.removeGifts();
        await this.read();
        this.message = this.config.text.removed;
        return true;
      }
      return false;
    }
    async nativeRefresh() {
      const data = await this.request(`cart?sections=cart-drawer,main-cart,cart-icon-bubble,cart-live-region-text${this.previewQuery()}`);
      const focused = document.activeElement;
      const saved = [...document.querySelectorAll('[name="note"], #cart-drawer-terms, #cart-drawer-terms-cart')].map(el => ({ id: el.id, value: el.value, checked: el.checked }));
      const drawer = document.querySelector('cart-drawer');
      if (drawer?.renderContents && data['cart-drawer'] && data['cart-icon-bubble']) {
        drawer.renderContents({ sections: data }, true);
      }
      const mainItems = document.querySelector('#main-cart-items cart-items');
      if (mainItems?.renderContents && data['main-cart']) {
        mainItems.renderContents({ ...this.cart, sections: data });
      }
      const mappings = [
        ['main-cart', '#main-cart-items .js-cart-items'],
        ['main-cart', '#cart-summary .js-subtotal'],
        ['main-cart', '#cart-summary .js-free-shipping-bar'],
        ['main-cart', '#cart-summary .cart__recommendations'],
        ['cart-icon-bubble', '#cart-icon-bubble'],
        ['cart-live-region-text', '#cart-live-region-text']
      ];
      for (const [section, selector] of mappings) {
        if (section === 'main-cart' && mainItems?.renderContents) continue;
        const target = document.querySelector(selector);
        if (!target || !data[section]) continue;
        const source = new DOMParser().parseFromString(data[section], 'text/html').querySelector(selector);
        if (source) { target.innerHTML = source.innerHTML; window.loadTemplateContent?.(target); }
      }
      for (const element of document.querySelectorAll('#main-cart, #main-cart-items cart-items, cart-drawer')) {
        element.classList.toggle('is-empty', this.cart.items.length === 0);
      }
      for (const savedInput of saved) {
        const input = document.getElementById(savedInput.id);
        if (input) { input.value = savedInput.value; input.checked = savedInput.checked; }
      }
      if (focused?.id) document.getElementById(focused.id)?.focus({ preventScroll: true });
    }
    async run(action) {
      if (this.busy) return;
      this.busy = true;
      this.render();
      const work = async () => {
        try { await action(); }
        catch (error) { this.message = this.config.text.error; }
        finally { this.busy = false; this.render(); this.idleWaiters.splice(0).forEach(resolve => resolve()); }
      };
      // Serializes this module across tabs when the browser supports Web Locks.
      if (navigator.locks) await navigator.locks.request('qunature-cart-rewards', work);
      else await work();
    }
    async refresh() {
      await this.run(async () => {
        await this.read();
        // The campaign builder owns its add/discount transaction; only explicit gift
        // selection or native cart checkout may reconcile gifts on that page.
        if ((!this.campaignPage || this.config.scenePage) && await this.reconcile()) await this.nativeRefresh();
      });
    }
    schedule() {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => { if (this.busy) this.schedule(); else this.refresh(); }, 250);
    }
    async claim() {
      const chosen = Number(this.selected);
      if (this.cartNeedsReview) { window.location.href = this.config.root.replace(/\/$/,'')+'/cart'; return; }
      const checkout = this.config.single ? this.pendingCheckout : this.dialog?.open ? this.pendingCheckout : null;
      await this.run(async () => {
        this.message = '';
        await this.read();
        const variant = this.config.variants.find(v => v.id === chosen && v.available && v.tier === this.state.tier);
        if (!variant) { this.message = this.config.text.choose; return; }
        if (foreignCodes(this.cart, this.config).length) { this.message = this.config.text.conflict; return; }
        if (this.state.validGift && this.state.gifts[0].variant_id === chosen) return;
        try {
          await this.removeGifts();
          await this.request('cart/add.js', { items: [{ id: chosen, quantity: 1, properties: { [MARKER]: 'Gratis Geschenk' } }] });
          if (!this.config.single) await this.request('cart/update.js', { discount: this.config.codes[variant.tier - 1] });
          await this.read();
          if (!this.state.validGift) throw new Error('Gift was not free');
          this.message = this.config.text.ready;
          if (!checkout) this.pendingCheckout = null;
        } catch (error) {
          if (this.config.single) this.cartNeedsReview = true;
          // A timed-out POST may still succeed. Re-read and clean up, never blindly add twice.
          await this.removeGifts();
          await this.read();
          this.message = this.config.text.error;
        }
        await this.nativeRefresh();
      });
      if (checkout && this.state.validGift && this.state.gifts[0].variant_id === chosen) {
        this.pendingCheckout = checkout;
        this.continueCheckout();
      } else if (!checkout && this.state.validGift && this.state.gifts[0].variant_id === chosen) {
        this.dialog?.close();
      }
    }
    mount() {
      for (const host of document.querySelectorAll('.cart-drawer__footer, #cart-summary .cart__blocks, [data-qn-dialog-host]')) {
        if (!host.querySelector(':scope > .qn-rewards')) {
          const panel = document.createElement('section');
          panel.className = 'qn-rewards';
          panel.innerHTML = '<div class="qn-rewards-compact"><span class="qn-rewards-mini"><img data-mini-mask width="36" height="40" alt=""><img data-mini-pillow width="36" height="40" alt=""></span><span class="qn-rewards-caption"><strong data-compact-title></strong><small data-compact-detail></small></span><button type="button" data-open-picker></button></div><div class="qn-rewards-products"><div class="qn-rewards-product" data-mask><img width="120" height="120"><strong></strong><small></small></div><div class="qn-rewards-product" data-pillow><img width="120" height="120"><strong></strong><small></small></div></div><p data-summary></p><p data-upgrade hidden></p><div data-controls><div class="qn-rewards-fields"><div data-size-field><span data-size-label></span><div class="qn-rewards-options" data-size role="group"></div></div><div data-color-field><span data-color-label></span><div class="qn-rewards-options" data-color role="group"></div></div></div><button type="button" data-claim></button></div><p data-status role="status" aria-live="polite"></p><button type="button" class="qn-rewards-skip" hidden></button><div class="qn-rewards-footer"><a></a><details class="qn-rewards-conditions"><summary></summary><p class="qn-rewards-terms"></p></details></div>';
          const context = host.hasAttribute('data-qn-dialog-host') ? 'dialog' : host.closest('cart-drawer') ? 'drawer' : 'cart';
          panel.dataset.context = context;
          panel.querySelector('[data-open-picker]').addEventListener('click', () => {
            this.pendingCheckout = null;
            this.pickerContext = context;
            this.showGiftDialog();
          });
          for (const field of ['size', 'color']) {
            const group = panel.querySelector('[data-' + field + ']');
            group.id = 'qn-reward-' + context + '-' + field;
            const label = panel.querySelector('[data-' + field + '-label]');
            label.id = group.id + '-label';
            group.setAttribute('aria-labelledby', label.id);
            group.addEventListener('click', event => {
              const choice = event.target.closest('button[data-value]');
              if (!choice || choice.disabled || this.busy) return;
              this[field] = choice.dataset.value;
              const variant = this.config.variants.find(v => v.available && v.tier === this.state.tier && (this.state.tier === 1 || v.size === this.size) && v.color === this.color);
              this.selected = variant ? String(variant.id) : '';
              this.render();
            });
          }
          panel.querySelector('[data-claim]').addEventListener('click', () => this.claim());
          panel.querySelector('.qn-rewards-skip').addEventListener('click', () => this.continueCheckout());
          host.prepend(panel);
        }
      }
    }
    sizeName(value) {
      const key = /^M(?:\b|:)/i.test(value) ? 'youth' : /^L(?:\b|:)/i.test(value) ? 'adult' : '';
      return key ? this.config.text[key] : value;
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: 'EUR' }).format(cents / 100); }
    renderSingle() {
      const state = this.state, map = this.config.singleMap;
      const displayTier = map.thresholds.reduce((level,threshold,index)=>state.subtotal>=threshold?index+1:level,0);
      if (this.lastSingleTier !== displayTier) { this.singleSocks=''; this.singleMask=''; this.lastSingleTier=displayTier; }
      const variants = this.config.variants.filter(v=>v.tier===displayTier && v.available);
      const saved = state.validGift ? this.config.variants.find(v=>v.id===state.gifts[0].variant_id) : null;
      if (saved && !this.singleSocks) { this.singleSocks=saved.socksSize; this.singleMask=saved.maskSize || ''; }
      const chosen = variants.find(v=>v.socksSize===this.singleSocks && (displayTier===1 || v.maskSize===this.singleMask));
      this.selected = chosen ? String(chosen.id) : '';
      const names=['Wasserdichte Socken','Socken + Sturmhaube','Socken + Sturmhaube + 1 Trekkingstock'];
      for (const panel of document.querySelectorAll('.qn-rewards')) {
        panel.hidden = state.scenePack;
        if (panel.dataset.single !== 'true') {
          panel.dataset.single='true';
          panel.innerHTML='<h3 data-single-title></h3><p data-single-progress></p><div class="qn-single-gift-images"></div><p data-single-details></p><label data-single-socks-label>Socken · Größe<select data-single-socks></select></label><label data-single-mask-label>Sturmhaube · Größe<select data-single-mask></select></label><button type="button" data-single-claim></button><p data-single-status role="status" aria-live="polite"></p><button type="button" data-single-skip hidden>Ohne Geschenk weiter</button><small>Nur ausgewählte Aktionsartikel. Es gilt die höchste Stufe, einmal pro Bestellung. Gratisgeschenke und Versand zählen nicht mit. Nicht mit Komplettset-Geschenken oder anderen Rabatten kombinierbar.</small>';
          panel.querySelector('[data-single-socks]').addEventListener('change',e=>{this.singleSocks=e.target.value;this.render();});
          panel.querySelector('[data-single-mask]').addEventListener('change',e=>{this.singleMask=e.target.value;this.render();});
          panel.querySelector('[data-single-claim]').addEventListener('click',()=>this.claim());
          panel.querySelector('[data-single-skip]').addEventListener('click',()=>this.continueCheckout());
        }
        panel.querySelector('[data-single-title]').textContent = displayTier ? 'Dein kostenloses Geschenk: '+names[displayTier-1] : 'Deine Geschenke beim Einzelkauf';
        const next=map.thresholds[displayTier];
        panel.querySelector('[data-single-progress]').textContent=next ? `Aktionswarenwert: ${this.money(state.subtotal)}. Noch ${this.money(next-state.subtotal)} bis ${names[displayTier]}.` : `Aktionswarenwert: ${this.money(state.subtotal)}. Höchste Geschenkstufe erreicht.`;
        panel.querySelector('[data-single-details]').textContent=displayTier===3?'Enthalten: 1 Paar Socken, 1 Sturmhaube und 1 einzelner violetter Trekkingstock.':'Ab 89 €: Socken · ab 139 €: zusätzlich Sturmhaube · ab 209 €: zusätzlich 1 einzelner Trekkingstock.';
        const imageHost=panel.querySelector('.qn-single-gift-images');imageHost.replaceChildren();
        for (const kind of ['socks','mask','stick'].slice(0,Math.max(1,displayTier))) {
          const image=map.choices[kind]?.[0]?.image;if(!image)continue;
          const img=document.createElement('img');img.src=image;img.alt={socks:'Wasserdichte Socken',mask:'Sturmhaube',stick:'Einzelner Trekkingstock'}[kind];img.width=80;img.height=80;imageHost.append(img);
        }
        for (const [kind,field] of [['socks','socksSize'],['mask','maskSize']]) {
          const select=panel.querySelector(`[data-single-${kind}]`);
          const value=kind==='socks'?this.singleSocks:this.singleMask;
          const options=[...new Set(variants.map(v=>v[field]).filter(Boolean))];
          select.replaceChildren();
          const empty=document.createElement('option');empty.value='';empty.textContent='Bitte auswählen';select.append(empty);
          for(const size of options){const option=document.createElement('option');option.value=size;option.textContent=size;select.append(option);}
          select.value=value;select.disabled=this.busy || !displayTier;
          panel.querySelector(`[data-single-${kind}-label]`).hidden=kind==='mask'?displayTier<2:displayTier<1;
        }
        const button=panel.querySelector('[data-single-claim]');
        button.textContent=this.cartNeedsReview?'Warenkorb prüfen':this.busy?'Wird geprüft …':!this.config.enabled?'Geschenkaktion wird vorbereitet':state.validGift?'Geschenkauswahl aktualisieren':'Geschenk kostenlos hinzufügen';
        button.disabled=this.busy || (!this.cartNeedsReview && (!state.active || !this.selected));
        panel.querySelector('[data-single-status]').textContent=this.message || (state.validGift?this.config.text.ready:foreignCodes(this.cart,this.config).length?this.config.text.conflict:'');
        const skip=panel.querySelector('[data-single-skip]');skip.hidden=!this.pendingCheckout;skip.disabled=this.busy;
      }
    }
    render() {
      const renderMode = this.config.single ? 'single' : 'legacy';
      if (this.renderMode && this.renderMode !== renderMode) document.querySelectorAll('.qn-rewards').forEach(panel=>panel.remove());
      this.renderMode = renderMode;
      this.mount();
      if (this.config.single) { this.renderSingle(); return; }
      const { text } = this.config;
      const state = this.state;
      const variants = this.config.variants.filter(v => v.available && v.tier === state.tier);
      if (this.lastTier !== state.tier) { this.size = ''; this.color = ''; this.selected = ''; this.lastTier = state.tier; }
      const current = this.config.variants.find(v => v.id === Number(this.selected)) ||
        (state.validGift ? this.config.variants.find(v => v.id === state.gifts[0].variant_id) : null);
      const pillow = variants.find(v => v.color === this.color) || current;
      for (const panel of document.querySelectorAll('.qn-rewards')) {
        panel.hidden = state.scenePack || (!state.active && !(state.gifts.length && this.message));
        const isDialog = panel.dataset.context === 'dialog';
        panel.querySelector('.qn-rewards-compact').hidden = isDialog;
        panel.querySelector('.qn-rewards-products').hidden = !isDialog;
        const saved = state.validGift ? this.config.variants.find(v => v.id === state.gifts[0].variant_id) : null;
        const compactTitle = panel.querySelector('[data-compact-title]');
        compactTitle.textContent = saved ? text.ready : text.heading;
        panel.querySelector('[data-compact-detail]').textContent = saved
          ? text.mask_name + ' · ' + saved.color + (saved.tier === 2 ? ' / ' + text.pillow_name + ' · ' + this.sizeName(saved.size) : '')
          : text.mask_name + (state.tier === 2 ? ' + ' + text.pillow_name : '');
        panel.querySelector('[data-mini-mask]').src = pillow?.image || this.config.images.mask;
        const miniPillow = panel.querySelector('[data-mini-pillow]');
        miniPillow.hidden = saved ? saved.tier !== 2 : state.tier !== 2;
        miniPillow.src = this.config.images.pillow;
        const opener = panel.querySelector('[data-open-picker]');
        opener.textContent = saved ? text.change : text.choose;
        opener.hidden = !state.tier || !variants.length;
        opener.disabled = this.busy;
        panel.querySelector('.qn-rewards-conditions').hidden = !isDialog;
        for (const [type, tier] of [['mask', 1], ['pillow', 2]]) {
          const product = panel.querySelector(`[data-${type}]`);
          const name = text[type === 'mask' ? 'mask_name' : 'pillow_name'];
          product.querySelector('strong').textContent = name;
          product.querySelector('small').textContent = state.tier >= tier ? text.free : text.from.replace('[amount]', this.money(this.config.thresholds[tier - 1]));
          const img = product.querySelector('img');
          const url = type === 'mask' ? pillow?.image || this.config.images?.mask : this.config.images?.pillow;
          if (url && img.getAttribute('src') !== url) img.src = url;
          img.alt = type === 'mask' && pillow?.color ? `${name} – ${pillow.color}` : name;
          product.hidden = panel.dataset.context === 'dialog' && tier > state.tier;
        }
        const summary = panel.querySelector('[data-summary]');
        summary.hidden = isDialog || state.tier > 0;
        summary.textContent = text.progress.replace('[amount]', this.money(Math.max(0, this.config.thresholds[0] - state.subtotal)));
        const upgrade = panel.querySelector('[data-upgrade]');
        upgrade.hidden = isDialog || state.validGift || state.tier !== 1;
        upgrade.textContent = text.upgrade.replace('[amount]', this.money(Math.max(0, this.config.thresholds[1] - state.subtotal)));
        const controls = panel.querySelector('[data-controls]');
        controls.hidden = !isDialog || !state.tier || !variants.length;
        panel.querySelector('[data-size-field]').hidden = state.tier !== 2;
        panel.querySelector('[data-color-field]').hidden = !state.tier;
        for (const field of ['size', 'color']) {
          panel.querySelector('[data-' + field + '-label]').textContent = field === 'size' ? text.pillow_name + ' · ' + text.size : text.mask_name + ' · ' + text.color;
          const group = panel.querySelector('[data-' + field + ']');
          const options = [...new Set(variants.map(v => v[field]).filter(Boolean))];
          const signature = JSON.stringify(options.map(value => [value, field === 'size' ? this.sizeName(value) : variants.find(v => v.color === value)?.image]));
          if (group.dataset.options !== signature) {
            group.replaceChildren(...options.map(value => {
              const choice = document.createElement('button');
              choice.type = 'button'; choice.className = 'qn-rewards-choice'; choice.dataset.value = value;
              if (field === 'color') {
                const img = document.createElement('img');
                img.src = variants.find(v => v.color === value).image; img.alt = ''; img.width = 64; img.height = 56;
                choice.append(img, document.createTextNode(value));
              } else {
                const title = document.createElement('strong'); title.textContent = this.sizeName(value);
                const detail = document.createElement('small');
                detail.textContent = text.circumference + ' ' + value.replace(/^[^:]+:\s*/, '');
                choice.append(title, detail);
              }
              return choice;
            }));
            group.dataset.options = signature;
          }
          for (const choice of group.querySelectorAll('button')) {
            const other = field === 'size' ? 'color' : 'size';
            choice.disabled = this.busy || !variants.some(v => v[field] === choice.dataset.value && (!this[other] || state.tier === 1 || v[other] === this[other]));
            choice.setAttribute('aria-pressed', String(choice.dataset.value === this[field]));
          }
        }
        const button = panel.querySelector('[data-claim]');
        button.textContent = this.busy ? text.busy : panel.dataset.context === 'dialog' && this.pendingCheckout ? text.add_checkout : state.validGift ? text.change : text.add;
        button.disabled = this.busy || !this.selected;
        panel.querySelector('[data-status]').textContent = (this.message === text.ready ? '' : this.message) || (state.tier && !variants.length ? text.sold_out : '');
        const skip = panel.querySelector('.qn-rewards-skip');
        skip.hidden = !this.pendingCheckout || panel.dataset.context !== 'dialog';
        skip.disabled = this.busy;
        skip.textContent = text.skip;
        panel.querySelector('.qn-rewards-terms').textContent = text.terms;
        panel.querySelector('.qn-rewards-conditions > summary').textContent = text.terms_label;
        const link = panel.querySelector('a');
        link.hidden = !state.active;
        link.href = this.config.root.replace(/\/$/, '') + '/collections/outlet';
        link.textContent = text.link;
      }
    }
    continueCheckout() {
      const pending = this.pendingCheckout;
      if (!pending || this.busy) return;
      const form = document.getElementById(pending.formId);
      const button = document.getElementById(pending.buttonId);
      if (!form || !button) return;
      if (this.dialog?.open) this.dialog.close();
      this.allowSubmit = true;
      try { form.requestSubmit(button); } finally { this.allowSubmit = false; }
      this.pendingCheckout = null;
    }
    showGiftDialog() {
      if (this.state.scenePack) return;
      if (this.config.single) {
        this.render();
        const panel = document.querySelector('.qn-rewards:not([hidden])');
        panel?.scrollIntoView({block:'nearest'});panel?.querySelector('select')?.focus();return;
      }
      if (!this.dialog) {
        this.dialog = document.createElement('dialog');
        this.dialog.className = 'qn-rewards-dialog';
        this.dialog.setAttribute('aria-labelledby', 'qn-reward-dialog-title');
        this.dialog.setAttribute('aria-describedby', 'qn-reward-dialog-description');
        this.dialog.innerHTML = '<button class="qn-rewards-dialog-close" type="button">×</button><h2 id="qn-reward-dialog-title"></h2><p id="qn-reward-dialog-description"></p><div data-qn-dialog-host></div>';
        this.dialog.querySelector('button').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => {
          this.pendingCheckout = null;
          if (this.pickerContext) document.querySelector('.qn-rewards[data-context="' + this.pickerContext + '"] [data-open-picker]')?.focus({ preventScroll: true });
          this.pickerContext = null;
        });
        document.body.append(this.dialog);
      }
      this.dialog.querySelector('h2').textContent = this.config.text.dialog_title;
      this.dialog.querySelector('#qn-reward-dialog-description').textContent = this.config.text.prompt;
      this.dialog.querySelector('button').setAttribute('aria-label', this.config.text.close);
      this.message = '';
      if (this.state.validGift) {
        const saved = this.config.variants.find(v => v.id === this.state.gifts[0].variant_id && v.tier === this.state.tier && v.available);
        if (saved) { this.size = saved.size; this.color = saved.color; this.selected = String(saved.id); }
      }
      this.render();
      if (!this.dialog.open) this.dialog.showModal();
      this.dialog.querySelector(this.state.tier === 1 ? '[data-color] button:not(:disabled)' : '[data-size] button:not(:disabled)')?.focus();
    }
    async checkout(event) {
      if (this.allowSubmit || event.defaultPrevented || !['cart', 'CartDrawer-Form'].includes(event.target.id) || event.submitter?.name !== 'checkout') return;
      if ((!this.config.enabled || Date.now() >= Date.parse(this.config.ends)) && !hasCampaignGift(this.cart,this.config,this.singleMap) && !this.config.hasGift) return;
      // Let native validation and existing terms controls run before this handler.
      event.preventDefault();
      const pending = { formId: event.target.id, buttonId: event.submitter.id };
      while (this.busy) await new Promise(resolve => this.idleWaiters.push(resolve));
      await this.run(async () => {
        try { await this.read(); }
        catch (error) {
          // A rewards service failure must not stop ordinary paid-product checkout.
          if (!hasCampaignGift(this.cart,this.config,this.singleMap) && !this.config.hasGift) { this.pendingCheckout = pending; this.resumeAfterRun = true; return; }
          throw error;
        }
        if (await this.reconcile()) await this.nativeRefresh();
        this.pendingCheckout = pending;
        if (this.state.tier && !this.state.validGift && this.config.variants.some(v => v.available && v.tier === this.state.tier)) {
          this.message = this.config.text.prompt;
        } else {
          // Leave all native checkout submission behavior in place.
          this.resumeAfterRun = true;
        }
      });
      if (this.resumeAfterRun) { this.resumeAfterRun = false; this.continueCheckout(); }
      else if (this.pendingCheckout && this.state.tier && !this.state.validGift) this.showGiftDialog();
    }
    start() {
      this.render();
      document.addEventListener('submit', event => this.checkout(event));
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        for (const event of [PUB_SUB_EVENTS.cartUpdate, PUB_SUB_EVENTS.cartAdd, PUB_SUB_EVENTS.cartRemove, PUB_SUB_EVENTS.cartOpen]) {
          if (event) subscribe(event, () => this.schedule());
        }
      }
      const observer = new MutationObserver(records => {
        if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 &&
          !node.closest?.('.qn-rewards') && (node.matches?.('.cart-drawer__footer, .cart__blocks') || node.querySelector?.('.cart-drawer__footer, .cart__blocks'))))) this.schedule();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      window.addEventListener('pageshow', () => this.schedule());
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.schedule(); });
      const untilEnd = Date.parse(this.config.ends) - Date.now();
      if (untilEnd > 0) setTimeout(() => this.schedule(), Math.min(untilEnd + 100, 2147483000));
      this.schedule();
    }
  }
  async function boot() {
    const node = document.querySelector('[data-qn-cart-rewards]');
    if (!node || window.qunatureCartRewards) return;
    const config = JSON.parse(node.textContent);
    let singleMap = null;
    if (config.singleMapUrl) {
      try {
        const response = await fetch(config.singleMapUrl,{credentials:'same-origin'});
        if (!response.ok) return;
        singleMap = await response.json();
        if (singleMap.schema !== 1 || singleMap.amountBasis !== 'final_line_price') return;
      } catch (_) { return; }
    }
    // Native cart drawers need rewards on campaign pages too.
    if ((!config.enabled || Date.now() >= Date.parse(config.ends)) && !config.hasGift && !singleMap) return;
    window.qunatureCartRewards = new Rewards(config,singleMap);
    window.qunatureCartRewards.start();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

  } catch(e) { console.error(e); }
})();
})();
